<template lang="pug">
#bloco-skeleton-dadosGerais
    el-skeleton(:loading='carregando', animated)
        template(slot='template')
            .skeleton-bloco-informacoes
                el-skeleton-item(variant='rect')
                el-skeleton-item(variant='rect')

            .skeleton-bloco-informacoes
                el-skeleton-item(variant='rect')
                el-skeleton-item(variant='rect')

            .skeleton-bloco-informacoes
                el-skeleton-item(variant='rect')
                el-skeleton-item(variant='rect')

            .skeleton-bloco-informacoes
                el-skeleton-item(variant='rect')
                el-skeleton-item(variant='rect')

            .skeleton-bloco-informacoes
                el-skeleton-item(variant='rect')
                el-skeleton-item(variant='rect')
        template
            slot
</template>

<script>
export default {
    name: 'BlocoSkeletonDadosGerais',
    props: {
        carregando: {
            type: Boolean,
            default: () => false
        }
    }
};
</script>

<style lang="scss">
#bloco-skeleton-dadosGerais {
    .width-interno {
        width: 50%;
    }
    .skeleton-bloco-informacoes {
        width: 10%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: column;
        gap: 23px;

        .el-skeleton__item.el-skeleton__rect {
            height: 33px;
        }
    }

    .el-skeleton {
        width: 100%;
        display: flex;
        gap: 10px;
        border-radius: 4px;
        background: #d6d6d6;
        justify-content: space-between;
        padding: 28px;
        min-height: 114px;
    }
}
</style>
